import {accessTokenName} from "@/interceptors/common";
import { ApolloClient, InMemoryCache, DefaultOptions, createHttpLink, from  } from '@apollo/client';
import {setContext} from "@apollo/client/link/context";
import {ErrorResponse, onError} from "@apollo/client/link/error";
import {isLocalhost} from "@/common/common";
import { notification } from 'antd';
const { VITE_API_HOST, VITE_GRAPHQL_POINT } = import.meta.env;

const defaultOptions: DefaultOptions = {
  query: {
    fetchPolicy: 'no-cache',
  },
  watchQuery: {
    fetchPolicy: 'no-cache',
  },
  mutate: {
    fetchPolicy: 'no-cache',
  },
};

const httpLink = createHttpLink({
  uri: isLocalhost()
    ? `${VITE_API_HOST}/${VITE_GRAPHQL_POINT}`
    : `${window.location.origin}/${VITE_GRAPHQL_POINT}`,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(accessTokenName);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const logoutLink = onError((error: ErrorResponse ) => {
    // Перевіряємо, чи це помилка з HTTP статусом 401
    if (error && 'statusCode' in error && (error as any).statusCode === 401) {
        console.warn('Сесія завершена...');

        notification.warning({
            message: 'Сесія завершена'
        });

        localStorage.removeItem(accessTokenName);

        // Невелика затримка, щоб юзер побачив нотифікацію
        setTimeout(() => {
            window.location.href = '/';
        }, 800);
    }
});

export const apolloClient = new ApolloClient({
  link: from([logoutLink, authLink, httpLink]),  //authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
});
